import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgConcreteTank = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 160,
	height: 75,
	viewBox: "0 0 160.0 75.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 10.0 0.0 L 10.0 65.0 L 150.0 65.0 L 150.0 0.0 L 160.0 0.0 L 160.0 75.0 L 0.0 75.0 Z M 0.0 5.0 L 5.0 0.0 M 0.0 15.0 L 10.0 5.0 M 0.0 25.0 L 10.0 15.0 M 0.0 35.0 L 10.0 25.0 M 0.0 45.0 L 10.0 35.0 M 0.0 55.0 L 10.0 45.0 M 40.0 75.0 L 50.0 65.0 M 0.0 65.0 L 10.0 55.0 M 0.0 75.0 L 10.0 65.0 M 10.0 75.0 L 20.0 65.0 M 20.0 75.0 L 30.0 65.0 M 30.0 75.0 L 40.0 65.0 M 50.0 75.0 L 60.0 65.0 M 60.0 75.0 L 70.0 65.0 M 70.0 75.0 L 80.0 65.0 M 80.0 75.0 L 90.0 65.0 M 90.0 75.0 L 100.0 65.0 M 110.0 75.0 L 120.0 65.0 M 120.0 75.0 L 130.0 65.0 M 130.0 75.0 L 140.0 65.0 M 140.0 75.0 L 160.0 55.0 M 150.0 75.0 L 160.0 65.0 M 150.0 55.0 L 160.0 45.0 M 150.0 45.0 L 160.0 35.0 M 150.0 35.0 L 160.0 25.0 M 150.0 25.0 L 160.0 15.0 M 150.0 15.0 L 160.0 5.0 M 150.0 5.0 L 155.0 0.0 M 100.0 75.0 L 110.0 65.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgConcreteTank;
